import { useEffect, useState } from 'react';

export const isLandingRoute = () =>
  location.pathname === '/' &&
  !new URLSearchParams(location.search).has('page');

export function useLandingRoute() {
  const [landing, setLanding] = useState(isLandingRoute);
  useEffect(() => {
    const sync = () => setLanding(isLandingRoute());
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);
  return [landing, setLanding] as const;
}

export async function authTimeout<T>(work: Promise<T>, ms = 15000): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      work,
      new Promise<never>((_, reject) => {
        timer = setTimeout(
          () => reject(Error('Sign-in took too long. Please try again.')),
          ms,
        );
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
